import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { App } from '@frontend/App/App';
import { AppOnboarding } from '@frontend/App/App.Onboarding';
import { DashboardPage } from '@frontend/Dashboard/DashboardPage';
import { DuplicatePage } from '@frontend/Duplicate/DuplicatePage';
import { LoginPage } from '@frontend/Login/LoginPage';
import { QuestionPage } from '@frontend/Question/QuestionPage';
import { QuestionPageUnauthorized } from '@frontend/Question/QuestionPageUnauthorized';
import { SearchPage } from '@frontend/Search/SearchPage';
import { SettingsPage } from '@frontend/Settings/SettingsPage';
import { DirectoryProvider } from '@frontend/shared/components/Directory/Directory';
import { BroadcasterProvider } from '@frontend/shared/hooks/shared.hook.useBroadcaster';
import { handleToken } from '@frontend/shared/util/util.handleToken';
import { TesterExtractPage } from '@frontend/Tester/Extract/TesterExtractPage';

handleToken();

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <BrowserRouter>
    <BroadcasterProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="tester" element={<TesterExtractPage />} />
        <Route path="/q/:id/:token" element={<QuestionPageUnauthorized />} />
        <Route
          path="*"
          element={
            <DirectoryProvider>
              <App>
                <Routes>
                  <Route path="/onboarding" element={<AppOnboarding />} />
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="/duplicates" element={<DuplicatePage />} />
                  <Route path="/questions" element={<SearchPage />} />
                  <Route path="/q/:id" element={<QuestionPage />} />
                  <Route
                    path="*"
                    element={<Navigate to="/questions" replace />}
                  />
                </Routes>
              </App>
            </DirectoryProvider>
          }
        />
      </Routes>
    </BroadcasterProvider>
  </BrowserRouter>,
);
